var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalender = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-12598 -496) translate(12598 496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e384d",
    d: "M7.909 4v.727H5v16h16v-16h-2.909V4h-1.455v.727H9.364V4zM6.455 6.182h1.454v.727h1.455v-.727h7.273v.727h1.455v-.727h1.455v1.454H6.455zm0 2.909h13.09v10.182H6.455zm4.364 1.455V12h1.455v-1.455zm2.909 0V12h1.455v-1.455zm2.909 0V12h1.455v-1.455zm-8.728 2.909v1.455h1.455v-1.455zm2.909 0v1.455h1.455v-1.455zm2.909 0v1.455h1.455v-1.455zm2.909 0v1.455h1.455v-1.455zm-8.727 2.909v1.455h1.455v-1.455zm2.909 0v1.455h1.455v-1.455zm2.909 0v1.455h1.455v-1.455z",
    transform: "translate(-12598 -496) translate(12597 496)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalender, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calender.4556c2a3.svg";
export { ForwardRef as ReactComponent };